<div>
    <div class="flex flex-row" style="justify-content: space-between;">
        <label style="align-content:center;font-size:18px;font-weight:bold">User Activity</label>
        <mat-form-field floatLabel="never" appearance="fill" style="width: 300px;">
            <input matInput placeholder="Search" (keyup)="search()" [(ngModel)]="searchText">
            <mat-icon aria-hidden="false" aria-label="search icon" matSuffix>
                search
            </mat-icon>
        </mat-form-field>
    </div>

    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="eventType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:20%;"> Event </th>
                <td mat-cell *matCellDef="let element"> {{element.eventType}} </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:50%;"> Description </th>
                <td mat-cell *matCellDef="let element"> {{element.description}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:15%;"> Date </th>
                <td mat-cell *matCellDef="let element"> {{element.date | date: 'MM/dd/yy, hh:mm a'}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                    <div class="p-4 text-center text-muted ">
                        <img src="./assets/images/no-data-placeholder.png " alt=" " class="pb-3 " />
                        <h6>No logs Found</h6>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>